
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Placeholder extends Vue {}
